// extracted by mini-css-extract-plugin
export default {"zoomControls":"yta-z","zoomControlButton":"zta-z","zoomBanner":"Ata-z","bannerButton":"Bta-z","imageButton":"Cta-z","zoom":"Dta-z","zoomContent":"Eta-z"};